<div class="row justify-content-center">
  <div class="col-6">
    <div class="row">
      <h5>{{ localizationKey('hospitalReportLanguageTitle') | localize }}</h5>
    </div>

    <div class="row mb-3">
      <label class="col-auto col-form-label"
             for="languageSelector">
        {{ localizationKey('hospitalDefaultReportLanguage') | localize }}:
      </label>

      <app-select class="col-auto"
                  [id]="'languageSelector'"
                  [inForm]="true"
                  [value]="language"
                  [options]="languageSelectionOptions"
                  [testId]="'hospital-language-select'"
                  (valueChanged)="onLanguageChange($event)"
      ></app-select>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <label class="w-100">
          <input
            type="checkbox"
            data-testid="report-language-toggle"
            [ngModel]="reportLanguageSelectionEnabled"
            (ngModelChange)="onReportLanguageSelectionEnabledChange($event)"
          />
          {{ localizationKey('hospitalNurseCanSelectReportLanguage') | localize }}
        </label>
      </div>
    </div>

    <div class="grid grid-striped" data-testid="allowed-report-languages" *ngIf="reportLanguageSelectionEnabled">
      <div class="row" *ngFor="let option of languageSelectionOptions">
        <div class="col-12">
          <label class="w-100">
            <input
              #allowedReportLanguageCheckbox
              type="checkbox"
              [attr.data-testid]="'allowed-report-language-' + option.value"
              [checked]="isAllowed(option.value!)"
              [disabled]="isDisabled(option.value!)"
              (change)="onAllowedReportLanguageChange(option.value!, allowedReportLanguageCheckbox.checked)"
            />
            {{ option.text }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
